import URLConst from '../constants/URLConst';
import { fetchJSON, secureGET, securePUT } from '../utilities/FetchHelper';

class GroupPolicyService {

  getGroupPolicy(data) {
    let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_GROUP_POLICY
    for (const key in data) {
      url = url.replace('{' + key + '}', data[key])
    }

    return fetchJSON(url, secureGET()).then(response => {
      return response
    }).catch((error) => {
      throw error
    })
  }

  putGroupPolicy(data) {
    let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_GROUP_POLICY
    for (const key in data) {
      url = url.replace('{' + key + '}', data[key])
    }

    const putData = {
      hotelCode: data.hotelCode,
      groupPolicies: data.groupPolicies
    }

    return fetchJSON(url, { ...securePUT(), body: JSON.stringify(putData) }).then(response => {
      return response
    }).catch((error) => {
      throw error
    })
  }
}

export default new GroupPolicyService();